const REWARD_TYPE_BY_MEMBERSHIP = [
  { id: 'O', description: 'Beneficio' },
  { id: 'A', description: 'Reward de uso único' },
  { id: 'S', description: 'Beneficio especial' },
]

const REWARD_TYPE_BY_PRIZES = [
  { id: 'O', description: 'Recurrente' },
  { id: 'M', description: 'Uso Único' },
]

export { REWARD_TYPE_BY_MEMBERSHIP, REWARD_TYPE_BY_PRIZES }
